(function () {
  function buildModal() {
    var overlay = document.createElement('div');
    overlay.className = 'lc-video-modal-overlay';
    overlay.setAttribute('hidden', '');
    overlay.innerHTML =
      '<div class="lc-video-modal-content">' +
      '<button type="button" class="lc-video-modal-close" aria-label="Cerrar">&times;</button>' +
      '<div class="lc-video-modal-media"></div>' +
      '</div>';
    document.body.appendChild(overlay);
    return overlay;
  }

  var overlay = buildModal();
  var mediaWrap = overlay.querySelector('.lc-video-modal-media');
  var closeBtn = overlay.querySelector('.lc-video-modal-close');

  function closeModal() {
    var media = mediaWrap.querySelector('video, iframe');
    if (media && media.tagName === 'VIDEO') {
      media.pause();
    }
    mediaWrap.innerHTML = '';
    overlay.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }

  function openModal(templateEl) {
    mediaWrap.innerHTML = '';
    var clone = templateEl.content.firstElementChild.cloneNode(true);
    if (clone.tagName === 'VIDEO') {
      clone.setAttribute('controls', '');
      clone.removeAttribute('muted');
      clone.removeAttribute('autoplay');
      clone.setAttribute('playsinline', '');
      clone.autoplay = true;
    } else if (clone.tagName === 'IFRAME') {
      var sep = clone.src.indexOf('?') > -1 ? '&' : '?';
      clone.src += sep + 'autoplay=1';
    }
    mediaWrap.appendChild(clone);
    overlay.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
  }

  document.addEventListener(
    'click',
    function (e) {
      var poster = e.target.closest('.deferred-media__poster');
      if (!poster) return;
      var component = poster.closest('video-component');
      if (!component || component.getAttribute('loaded')) return;
      var template = component.querySelector('template');
      if (!template) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      openModal(template);
    },
    true
  );

  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeModal();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !overlay.hasAttribute('hidden')) closeModal();
  });
})();
